import gql from "graphql-tag";

export const GET_REQUESTED_TO_ME_ORDERS = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "InTransit"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]}]}, order_by: {createdOn: desc}){      
      id
      from
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        productId
        FromOrganization{name PartnerType{name prefix} }
        ToOrganization{name PartnerType{name prefix} }
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`
export const GET_ORDER_BATCHES_GROUPBY_PRODUCT = gql`
query Product($orderId: uuid!){
 Product {
    id
    name
    productLineCode
    OrderItems(where: {orderId: {_eq: $orderId}}) {
      id  
      Batch { id batch }
    }
  }
}
`

export const GET_ORDER_BATCHES_GROUPBY_PRODUCT_ONLINE = gql`
query OnlineProducts($orderId: uuid!){
  OnlineProducts {
    id
    name
    productLineCode
    OrderItems(where: {orderId: {_eq: $orderId}}) {
      id  
      Batch { id batch }
    }
  }
}
`

export const GET_ORDER_SKU_GROUPBY_PRODUCT = gql`
query Product($orderId: uuid!){
 Product {
    id
    name
    OrderItems(where: {orderId: {_eq: $orderId}}) {
      id
      meta  
      ProductInventory { id sku serial }
    }
  }
}
`

export const GET_TRANSIT_ORDERS = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "InTransit"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]}]}, order_by: {createdOn: desc}){      
      id
      from
      date
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        productId
        ToOrganization{name PartnerType{name prefix} }
        FromOrganization{name PartnerType{name prefix} }
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`

export const GET_SOLD_ORDERS = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Sold"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]}]}, order_by: {createdOn: desc}){      
      id
      from
      date
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        ToOrganization{name PartnerType{name prefix} }
        FromOrganization{name PartnerType{name prefix} }
        productId
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`

export const GET_PAID_ORDERS_PURCHASE = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "Paid"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]}]}, order_by: {createdOn: desc}){      
      id
      from
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        productId
        ToOrganization{name PartnerType{name prefix} }
        FromOrganization{name PartnerType{name prefix} }
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`
export const GET_PAID_ORDERS_SALES = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Paid"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]}]}, order_by: {createdOn: desc}){      
      id
      from
      date
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        productId
        ToOrganization{name PartnerType{name prefix} }
        FromOrganization{name PartnerType{name prefix} }
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`
export const GET_DUE_ORDERS= gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "Sold"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]}]}, order_by: {createdOn: desc}){      
      id
      from
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        productId
        FromOrganization{name PartnerType{name prefix} }
        ToOrganization{name PartnerType{name prefix} }
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`
export const GET_PAID_ORDERS_FOR_OTHERS = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "Paid"}}]}, order_by: {createdOn: desc}){      
      id
      from
      PlacedBy{id name}
      orderNum
      OrderItems{
        productId
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        Batch{batch id productId status sku}
      }
 }
}
`

export const CANCEL_ORDER = gql`
mutation cancel_order($orderId:uuid!, $lastUpdatedBy:uuid!){
    update_Orders(where:{id:{_eq:$orderId}},_set:{status:"Rejected",lastUpdatedBy:$lastUpdatedBy}){
         returning{id status}
    }
    update_OrderItems(where:{orderId:{_eq:$orderId}},_set:{status:"Rejected",lastUpdatedBy:$lastUpdatedBy}){
        returning{id status}
    }
}
`

export const GET_RETAIL_SALES_ORDERS = gql`
query Orders($orgId: uuid!){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Sold"}},{orderType: {_eq: 2}}]}, order_by: {createdOn: desc}){      
      id
      date
      createdOn
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{
        productId
        meta
        ToCustomer{id name mobile email}
        FromOrganization{name PartnerType{name prefix} }
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM {name}}
        ProductInventory{id productId sku serial}
      }
 }
}
`
export const GET_RETAIL_ORDERITEMS = gql`
query RetailOrderItems($orderId: uuid!){
 OrderItems(where: {orderId: {_eq: $orderId}}){      
      id
      meta  
      ProductInventory { id sku serial }
      Product{ id validity }
 }
}
`